import { useQuery } from "@tanstack/react-query";

import { billingQueriesStore } from "@/features/billing/api";
import type { Subscription } from "@/features/billing/models";

interface UseCancellationDiscountProps {
  subscriptionId: Subscription["id"];
  enabled?: boolean;
}

export const useCancellationDiscount = ({
  subscriptionId,
  enabled = true,
}: UseCancellationDiscountProps) => {
  return useQuery({
    ...billingQueriesStore.subscriptions._ctx.cancellationDiscount(
      subscriptionId,
    ),
    staleTime: Infinity,
    enabled,
  });
};
